import service from "@/libs/service";

export const namespaced = true;

export const state = {
    fixtures: {
    }
};

export const mutations = {
    SET_FIXTURES(state, fixtures) {
        state.fixtures = fixtures;
    }
};

export const actions = {
    get({ commit }, resource) {
        return new Promise((resolve, reject) => {
            service.request("/fixtures").then(content => {
                commit("SET_FIXTURES", content);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    }
};

export const getters = {
    getCities(state) {
        return state.fixtures.cities;
    },
    getLevels(state) {
        return state.fixtures.levels;
    },
    getProfessions(state) {
        return state.fixtures.professions;
    },
    getAreas(state) {
        return state.fixtures.areas;
    },
    getSegments(state) {
        return state.fixtures.segments;
    },
    getGenders(state) {
        return state.fixtures.genders;
    },
    getWorkingDay(state) {
        return state.fixtures.workingDay;
    },
    getWorkingMode(state) {
        return state.fixtures.workingMode;
    },
    getBenefits(state) {
        return state.fixtures.benefits;
    },
    getDegree(state) {
        return state.fixtures.degree;
    }
};
